const withdrawIntentDictEN = {
  paypalEmail: "Insert PayPal email below",
  amountWithdrawn: "Withdrawn amount from wallet",
  amountDeposited: "Deposited amount in PayPal",
  withdrawFee: "withdraw fee",
  paypalFee: "PayPal will apply a fee of",
  onTop: "on the amount transferred",
  requestWithdraw: "Request withdraw",
  amountWithdrawnSuccessfully: "Amount withdrawn successfully!",
  invalidemail: "invalid email",
  withdrawRequests: "Withdraw requests",
  requestDate: "Request date",
  processDate: "Process date",
  processing: "Processing",
  amountToDeposit: "Amount to deposit",
  amountRequested: "Amount requested",
  processRequest: "Process request",
  process: "Process",
  withdrawProcessedSuccessfully: "Withdraw request processed successfully!",
  withdrawWith: "Withdraw with",
  bank: "Bank",
  bankName: "Bank name",
  bankAccountNumber: "Bank account number",
  accountOwner: "Account owner name",
  allFieldsRequired: "All fields are required",
  previousBankDataFound: "Previous bank data found:",
  previousPaypalEmailsFound: "Previous PayPal emails found:",
  clickToUseOrTypeNew: "Click to use or type a new one",
  cashbackForBuyer: "Cashback for buyer",
  cashbackToBuyersSponsor: "Cashback for buyer's sponsor",
  cashbackToSellersSponsor: "Cashback for seller's sponsor",
  amountToBeReceived: "Amount to be received",
  withdrawalRequestsPageTitle: "Withdrawal requests",
  withdrawalRequestsSubtitle: "History of withdrawal requests made.",
  account: "Account",
  amountToTransfer: "Amount to transfer",
  fee: "Fee",
  noWithdrawalRequests: "No withdrawal requests yet.",
};

export default withdrawIntentDictEN;
